module.exports = __webpack_public_path__ + "static/media/608.629960d0.webp";